(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('theme-classify', {
            parent: 'entity',
            url: '/theme-classify?page&sort&search&classType',
            data: {
                authorities: ["ROLE_THEME_CATEGORY"],
                pageTitle: 'platformApp.themeClassify.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/theme-classify/theme-classify.html',
                    controller: 'ThemeClassifyController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        classType: $stateParams.classType
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('themeClassify');
                    $translatePartialLoader.addPart('reprintType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
         ;
    }

})();
